import _ from 'lodash';
import React from 'react';

/**
 * Builds project template cards for a given project type
 */
export const buildProjectTemplateCards = ({
  project_type,
  selectedProjectTemplate,
  currentUser,
  currentCompany,
  animateExpand,
  handleDeleteProjectTemplate,
  handleUpdateProjectTypeTemplates,
  handleEditTemplateName,
  ProjectTemplateCard,
}) => {
  let projectTemplateCards = [];
  
  if (project_type.project_templates) {
    // Group by group_identifier; use template id when missing so each template still gets a card
    const projectTemplateGroups = _.groupBy(project_type.project_templates, projectTemplate =>
      projectTemplate.group_identifier != null && projectTemplate.group_identifier !== ''
        ? projectTemplate.group_identifier
        : 'template_' + (projectTemplate.id != null ? projectTemplate.id : '')
    );
    
    projectTemplateCards = Object.keys(projectTemplateGroups).map((groupIdentifier) => {
      const templateGroup = projectTemplateGroups[groupIdentifier];
      const groupHasSelectedTemplate = selectedProjectTemplate ? 
        templateGroup.find(template => template.id === selectedProjectTemplate.id) : false;

      return (
        <ProjectTemplateCard
          key={groupIdentifier}
          projectType={project_type}
          currentUser={currentUser}
          currentCompany={currentCompany}
          selectedProjectTemplate={groupHasSelectedTemplate ? selectedProjectTemplate : null}
          projectTemplateGroup={projectTemplateGroups[groupIdentifier]}
          animateExpand={animateExpand}
          handleDeleteProjectTemplate={handleDeleteProjectTemplate}
          handleUpdateProjectTypeTemplates={handleUpdateProjectTypeTemplates}
          handleEditTemplateName={handleEditTemplateName}
          selectedTemplate={project_type.project_templates}
        />
      );
    });
  }
  
  return projectTemplateCards;
};

/**
 * Creates a popup menu for project type actions
 */
export const createMoreMenu = ({
  permissions,
  textMap,
  moreButtonRef,
  parentRef,
  handleMenuSelection,
  handleCloseMenu,
  PopupMenu,
}) => {
  let menuOptions = [];
  
  if (permissions.canEditProjectType) {
    menuOptions.push({
      type: 'edit',
      name: textMap.editProjectType,
    });
  }
  
  if (permissions.canDeleteProjectType) {
    menuOptions.push({
      type: 'delete',
      name: textMap.deleteProjectType,
    });
  }

  let left = 205;
  let top = 20;
  
  if (moreButtonRef.current && parentRef.current) {
    const rect = moreButtonRef.current.getBoundingClientRect();
    const parentRect = parentRef.current.getBoundingClientRect();
    left = (rect.left - parentRect.left) + rect.width + 20;
    top = (rect.top - parentRect.top) - 10;
  }
  
  return (
    <PopupMenu 
      left={left} 
      top={top} 
      width={200} 
      menuOptions={menuOptions} 
      size="smaller"
      menuId="project-typeMenu" 
      popupOnHover={false} 
      handleMenuSelection={handleMenuSelection}
      handleClickAway={handleCloseMenu} 
      pointerPosition="left" 
    />
  );
};

/**
 * Calculates the expanded state for the project type nav card
 */
export const calculateExpandedState = ({
  selectedProjectTemplate,
  selectedProjectType,
  selected,
  project_type,
  isExpanded,
  userHasToggled,
}) => {
  // Check if this project type should be auto-expanded due to selection
  const shouldAutoExpand = (selectedProjectTemplate && selectedProjectTemplate.project_type_id === project_type.id) || 
                          selected || 
                          (selectedProjectType && selectedProjectType.id === project_type.id);
  
  // Use local state if user has manually toggled, otherwise use auto-expand logic
  if (userHasToggled) {
    // User has manually interacted, use their preference
    return isExpanded;
  } else if (shouldAutoExpand) {
    // Auto-expand when template is selected
    return true;
  } else {
    // Default to collapsed
    return false;
  }
};

/**
 * Stops event propagation
 */
export const stopEventPropagation = (e) => {
  e.stopPropagation();
};



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTypesNav/ProjectTypeNavCard/utils/navCardUtils.js